module.exports = __webpack_public_path__ + "img/cellbridge-device.bd96c51e.png";